import React from 'react';

const viUpload = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      width: '1em',
      height: '1em',
      overflow: 'visible',
    }}
  >
    <g fill="none" fillRule="evenodd">
      <path fill="currentColor" d="M9 16.5v-6H5l7-7 7 7h-4v6H9zm-4 2h14v2H5v-2z" />
    </g>
  </svg>
);

export default viUpload;
